import { render, staticRenderFns } from "./UnitDefinition.vue?vue&type=template&id=6d037482"
import script from "./UnitDefinition.vue?vue&type=script&lang=ts"
export * from "./UnitDefinition.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports